import classes from "./SiderContentC.module.css";
import { Menu, message } from "antd";
import React, { useState } from "react";
import {
  FaSignOutAlt,
  FaFileInvoice,
  FaHandsHelping,
} from "react-icons/fa";
import signInSignUpLogo from "../../../assets/signInSignUp.png";
import { MdDashboard } from "react-icons/md";
// import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { GiSellCard } from "react-icons/gi";
// import { GiBuyCard } from "react-icons/gi";
// import { AiOutlineDownSquare } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { MdAssignmentTurnedIn } from "react-icons/md";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
// import { AiFillFileMarkdown, AiFillPropertySafety } from "react-icons/ai";
import { GiRuleBook } from "react-icons/gi";
import { AiTwotoneRest} from "react-icons/ai";

const { SubMenu } = Menu;

const SiderContentS = (props) => {
  const history = useNavigate();
  const [selectedKeys, setSelectedKeys] = useState([]); // State to track selected keys

  const handleMenuItemClick = (key) => {
    setSelectedKeys([key]); // Update the selected key
  };

  const handleLogout = (event) => {
    axios
      .get(props.url + "/api/v1/users/logout", {
        withCredentials: true,
      })
      .then((response) => {
        message.success({
          content: "Goodbye!!!! See You Again!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        history("/");
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  return (
    <>
      <img
        className={classes["SignInSignUpLogo"]}
        src={signInSignUpLogo}
        alt="Logo"
      />
      <Menu
        mode="inline"
        defaultSelectedKeys={["empDashboard"]}
        style={{
          height: "100%",
          borderRight: 0,
          overflowY: "auto",
        }}
        theme="light"
      >
        <Menu.Item key="empDashboard" icon={<MdDashboard />}>
          <Link to="/sales/dashboard" style={{ textDecoration: "none" }}>
            Dashboard
          </Link>
        </Menu.Item>
        <Menu.Item key="custInvoices" icon={<FaFileInvoice />}>
          <Link
            to="/sales/invoices-register"
            style={{ textDecoration: "none" }}
          >
            Invoices Register
          </Link>
        </Menu.Item>

        <Menu.Item key="custOrder" icon={<FaHandsHelping />}>
          <Link to="/sales/order-register" style={{ textDecoration: "none" }}>
            Order Register
          </Link>
        </Menu.Item>

        <Menu.Item key="custPendingSales" icon={<GiSellCard />}>
          <Link
            to="/sales/pending-sales-register"
            style={{ textDecoration: "none" }}
          >
            Pending Order Register
          </Link>
        </Menu.Item>

        {/* <Menu.Item key="custledger" icon={<FaReceipt />}>
          <Link to="/sales/ledger" style={{ textDecoration: "none" }}>
            Ledger
          </Link>


        </Menu.Item> */}

        

        <SubMenu key="Masters" title="Masters" icon={<AiTwotoneRest />}>
          <Menu.Item key="itemMaster">
            <Link
              to="/sales/itemMaster/item-details"
              style={{ textDecoration: "none" }}
            >
              Item Master
            </Link>
          </Menu.Item>
          <Menu.Item key="customerMaster">
            <Link
              to="/sales/customerMaster/customer-details"
              style={{ textDecoration: "none" }}
            >
              Customer Master
            </Link>
          </Menu.Item>
          {/* <Menu.Item key="categoryDetail">   
                    <NavLink to = '/sales/categoryDetail/category-Details'>
                        Category Detail
                    </NavLink>
                </Menu.Item> */}
          <Menu.Item key="DealerMaster">
            <Link
              to="/sales/DealerMaster/dealer-details"
              style={{ textDecoration: "none" }}
            >
              Dealer Master
            </Link>
          </Menu.Item>
          {/* <Menu.Item key="chargedefMaster">   
                <NavLink to = '/sales/chargedefMaster/charge-details'>
                    Chargedef Master
                </NavLink>
            </Menu.Item> */}
          <Menu.Item key="accountmaster">
            <Link
              to="/sales/accountmaster/account-details"
              style={{ textDecoration: "none" }}
            >
              Account Master
            </Link>
          </Menu.Item>

          <Menu.Item key="groupmaster">
            <Link
              to="/sales/groupmaster/group-details"
              style={{ textDecoration: "none" }}
            >
              Group Master
            </Link>
          </Menu.Item>

          <Menu.Item key="statemaster">
            <Link
              to="/sales/statemaster/state-details"
              style={{ textDecoration: "none" }}
            >
              State Master
            </Link>
          </Menu.Item>

          <Menu.Item key="citymaster">
            <Link
              to="/sales/citymaster/city-details"
              style={{ textDecoration: "none" }}
            >
              City Master
            </Link>
          </Menu.Item>
          <Menu.Item key="localitymaster">
            <Link
              to="/sales/localitymaster/locality-details"
              style={{ textDecoration: "none" }}
            >
              Locality Master
            </Link>
          </Menu.Item>
        </SubMenu>



        <SubMenu key="norms" title="Norms" icon={<GiRuleBook />}>
          {/* <Menu.Item key="DiscountNorms" >
                        <NavLink to = '/sales/norms/leave-norms'>
                            Discount Norms
                        </NavLink>
                    </Menu.Item> */}
          {/* <Menu.Item key="GaugeNorms">
            <Link
              to="/sales/norms/gauge-detail"
              style={{ textDecoration: "none" }}
            >
              Gauge Policy
            </Link>
          </Menu.Item> */}
          <Menu.Item key="Charge Master">
            <Link
              to="/sales/norms/charge-detail"
              style={{ textDecoration: "none" }}
            >
              Charge Master
            </Link>
          </Menu.Item>

          <Menu.Item key="itemWiseTax">
            <Link
              to="/sales/norms/tax-details"
              style={{ textDecoration: "none" }}
            >
              Item Wise Tax
            </Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu
          key="transactions"
          title="Transactions"
          icon={<MdAssignmentTurnedIn />}
        >
          <Menu.Item key="Salesform">
            <Link
              to="/sales/transaction/salesForm"
              style={{ textDecoration: "none" }}
            >
              Sales Contract
            </Link>
          </Menu.Item>
          <Menu.Item key="SalesOrder">
            <Link
              to="/sales/transaction/salesOrder-detail"
              style={{ textDecoration: "none" }}
            >
              Sales Order
            </Link>
          </Menu.Item>
          <Menu.Item key="SalesInvoice">
            <Link
              to="/sales/transaction/salesInvoice-detail"
              style={{ textDecoration: "none" }}
            >
              Sales Invoice
            </Link>
          </Menu.Item>
          {/* <Menu.Item key="Voucher">
            <Link
              to="/sales/transaction/Voucher"
              style={{ textDecoration: "none" }}
            >
              Voucher
            </Link>
          </Menu.Item> */}

          {/* <Menu.Item key="SalesPacking">
            <Link
              to="/sales/transaction/packingform"
              style={{ textDecoration: "none" }}
            >
              Packing List
            </Link>
          </Menu.Item> */}

          <Menu.Item key="SalesReturn">
            <Link
              to="/sales/transaction/sales-return-details"
              style={{ textDecoration: "none" }}
            >
              Sales Return
            </Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu
          key="misc"
          title="Miscellaneous"
          icon={<BsFillGrid3X3GapFill />}
        >
          {/* <div style={{ height: "200px", overflowY: "auto" }}> */}
            {" "}
            {/* Set your desired height */}
            {props.miscList && props.miscList.length > 0 ? (
              <>
                {props.miscList.map((misc) => {
                  return (
                    <Menu.Item
                      key={misc.table_code}
                      onClick={() => handleMenuItemClick(misc.table_code)}
                    >
                      <Link
                        to={"/sales/misc/" + misc.slug}
                        style={{ textDecoration: "none" }}
                      >
                        {misc.form_name}
                      </Link>
                    </Menu.Item>
                  );
                })}
              </>
            ) : (
              <Menu.Item disabled>No items available</Menu.Item> // Optional: Show a message if no items
            )}
          {/* </div> */}
        </SubMenu>

        <Menu.Item
          key="empLogout"
          onClick={(event) => handleLogout(event)}
          icon={<FaSignOutAlt style={{ color: "red", opacity: "0.7" }} />}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            Logout
          </Link>
        </Menu.Item>
      </Menu>
    </>
  );
};

export default SiderContentS;
